import { render, staticRenderFns } from "./ProjectBenefitsAndRisks.vue?vue&type=template&id=7e5f0f19"
import script from "./ProjectBenefitsAndRisks.vue?vue&type=script&lang=js"
export * from "./ProjectBenefitsAndRisks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports